(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calorie-calculator"] && !Shopify.designMode) return;
  try {
    
(() => {
  const storageKey = 's3-calorie-calculator-v1';

  const roundTo = (value, increment = 1) => Math.round(value / increment) * increment;
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
  const formatKg = (value) => Number(value).toLocaleString('sk-SK', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

  const activityBase = {
    sedentary: 1.20,
    light: 1.30,
    active: 1.42,
    physical: 1.55
  };

  const trainingAdd = {
    '0': 0,
    '1-2': 0.06,
    '3-4': 0.12,
    '5+': 0.18
  };

  const stepsAdd = {
    unknown: 0,
    lt5: 0,
    '5-8': 0.03,
    '8-12': 0.07,
    '12+': 0.12
  };

  const paceRate = {
    slow: 0.0035,
    recommended: 0.0055,
    fast: 0.0075
  };

  function getFieldValue(form, name) {
    const field = form.elements[name];
    if (!field) return '';
    if (field instanceof RadioNodeList) return field.value;
    return field.value;
  }

  function saveState(form) {
    const names = ['sex', 'age', 'height', 'weight', 'targetWeight', 'dailyActivity', 'training', 'steps', 'pace'];
    const state = {};
    names.forEach((name) => { state[name] = getFieldValue(form, name); });
    try { localStorage.setItem(storageKey, JSON.stringify(state)); } catch (error) {}
  }

  function restoreState(form) {
    let state;
    try { state = JSON.parse(localStorage.getItem(storageKey) || '{}'); } catch (error) { state = {}; }
    Object.entries(state).forEach(([name, value]) => {
      if (!value || !form.elements[name]) return;
      const field = form.elements[name];
      if (field instanceof RadioNodeList) {
        const radio = form.querySelector(`input[name="${name}"][value="${CSS.escape(String(value))}"]`);
        if (radio) radio.checked = true;
      } else {
        field.value = value;
      }
    });
  }

  function validateInputs(data) {
    if (!data.sex || !data.dailyActivity || !data.training || !data.pace) return 'Vyplň, prosím, všetky údaje.';
    if (!Number.isFinite(data.age) || data.age < 18 || data.age > 75) return 'Zadaj vek od 18 do 75 rokov.';
    if (!Number.isFinite(data.height) || data.height < 140 || data.height > 220) return 'Skontroluj zadanú výšku.';
    if (!Number.isFinite(data.weight) || data.weight < 45 || data.weight > 250) return 'Skontroluj aktuálnu hmotnosť.';
    if (!Number.isFinite(data.targetWeight) || data.targetWeight < 45 || data.targetWeight > 250) return 'Skontroluj cieľovú hmotnosť.';
    if (data.targetWeight >= data.weight) return 'Cieľová hmotnosť musí byť nižšia ako aktuálna hmotnosť.';
    const currentBmi = data.weight / Math.pow(data.height / 100, 2);
    const targetBmi = data.targetWeight / Math.pow(data.height / 100, 2);
    if (currentBmi < 18.5 || targetBmi < 18.5) return 'Táto kalkulačka nie je určená na plánovanie chudnutia do pásma podváhy (BMI pod 18,5).';
    return '';
  }

  function calculate(data) {
    const bmr = data.sex === 'male'
      ? (10 * data.weight) + (6.25 * data.height) - (5 * data.age) + 5
      : (10 * data.weight) + (6.25 * data.height) - (5 * data.age) - 161;

    const multiplier = clamp(
      activityBase[data.dailyActivity] + trainingAdd[data.training] + stepsAdd[data.steps],
      1.16,
      1.90
    );

    const tdee = roundTo(bmr * multiplier, 10);
    const requestedWeeklyLoss = data.weight * paceRate[data.pace];
    const requestedDeficit = (requestedWeeklyLoss * 7700) / 7;
    const absoluteFloor = data.sex === 'male' ? 1500 : 1200;
    const calorieFloor = Math.max(tdee * 0.75, absoluteFloor);
    const rawCalories = tdee - requestedDeficit;
    const targetCalories = roundTo(Math.max(rawCalories, calorieFloor), 10);
    const safetyClamped = rawCalories < calorieFloor;
    const actualDeficit = Math.max(tdee - targetCalories, 0);
    const actualWeeklyLoss = Math.max((actualDeficit * 7) / 7700, 0.1);

    const protein = roundTo(data.targetWeight * 2.0, 5);
    let fat = roundTo(Math.max(data.targetWeight * 0.7, (targetCalories * 0.23) / 9), 5);
    let carbs = roundTo((targetCalories - (protein * 4) - (fat * 9)) / 4, 5);

    if (carbs < 90) {
      fat = roundTo(Math.max(data.targetWeight * 0.6, (targetCalories * 0.18) / 9), 5);
      carbs = roundTo(Math.max((targetCalories - (protein * 4) - (fat * 9)) / 4, 70), 5);
    }

    const gap = data.weight - data.targetWeight;
    const lowLoss = actualWeeklyLoss * 0.80;
    const highLoss = actualWeeklyLoss * 1.20;
    const fastWeeks = Math.max(1, Math.ceil(gap / highLoss));
    const slowWeeks = Math.max(fastWeeks, Math.ceil(gap / lowLoss));
    const centralWeeks = Math.max(1, Math.ceil(gap / actualWeeklyLoss));

    return {
      bmr,
      tdee,
      targetCalories,
      actualDeficit,
      actualWeeklyLoss,
      lowLoss,
      highLoss,
      fastWeeks,
      slowWeeks,
      centralWeeks,
      safetyClamped,
      protein,
      fat,
      carbs,
      proteinPerMeal: roundTo(protein / 4, 5),
      gap
    };
  }

  function drawChart(canvas, data, result) {
    if (!canvas) return;
    const rect = canvas.getBoundingClientRect();
    if (!rect.width) return;
    const dpr = window.devicePixelRatio || 1;
    const width = Math.round(rect.width);
    const height = Math.max(250, Math.round(rect.height || 280));
    canvas.width = Math.round(width * dpr);
    canvas.height = Math.round(height * dpr);
    const ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    ctx.clearRect(0, 0, width, height);

    const compactChart = width < 480;
    const pad = {
      top: compactChart ? 22 : 18,
      right: compactChart ? 14 : 16,
      bottom: compactChart ? 42 : 36,
      left: compactChart ? 60 : 50
    };
    const plotW = width - pad.left - pad.right;
    const plotH = height - pad.top - pad.bottom;
    const maxWeeks = Math.max(result.slowWeeks, 4);
    const maxWeight = data.weight + Math.max(1, result.gap * 0.08);
    const minWeight = data.targetWeight - Math.max(1, result.gap * 0.04);

    const x = (week) => pad.left + (week / maxWeeks) * plotW;
    const y = (weight) => pad.top + ((maxWeight - weight) / (maxWeight - minWeight)) * plotH;
    const projected = (week, rate) => Math.max(data.targetWeight, data.weight - (rate * week));

    ctx.font = `${compactChart ? '700 13px' : '600 12px'} Arial, sans-serif`;
    ctx.textBaseline = 'middle';

    for (let i = 0; i <= 4; i += 1) {
      const weight = maxWeight - ((maxWeight - minWeight) * i / 4);
      const py = y(weight);
      ctx.strokeStyle = 'rgba(255,255,255,.075)';
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(pad.left, py);
      ctx.lineTo(width - pad.right, py);
      ctx.stroke();
      ctx.fillStyle = compactChart ? 'rgba(255,255,255,.84)' : 'rgba(255,255,255,.68)';
      ctx.textAlign = 'right';
      ctx.fillText(`${Math.round(weight)} kg`, pad.left - 8, py);
    }

    let tickWeeks;
    if (maxWeeks <= 8) {
      tickWeeks = Array.from({ length: maxWeeks + 1 }, (_, week) => week);
    } else {
      const tickStep = Math.ceil(maxWeeks / 5);
      tickWeeks = [];
      for (let week = 0; week < maxWeeks; week += tickStep) tickWeeks.push(week);
      tickWeeks.push(maxWeeks);
    }

    [...new Set(tickWeeks)].forEach((week) => {
      ctx.fillStyle = compactChart ? 'rgba(255,255,255,.84)' : 'rgba(255,255,255,.68)';
      ctx.textAlign = 'center';
      ctx.fillText(week === 0 ? 'DNES' : `${week}t`, x(week), height - (compactChart ? 16 : 14));
    });

    const bandTop = [];
    const bandBottom = [];
    for (let week = 0; week <= maxWeeks; week += 1) {
      bandTop.push([x(week), y(projected(week, result.highLoss))]);
      bandBottom.push([x(week), y(projected(week, result.lowLoss))]);
    }

    ctx.beginPath();
    bandTop.forEach((point, index) => {
      if (index === 0) ctx.moveTo(point[0], point[1]);
      else ctx.lineTo(point[0], point[1]);
    });
    bandBottom.reverse().forEach((point) => ctx.lineTo(point[0], point[1]));
    ctx.closePath();
    const bandGradient = ctx.createLinearGradient(0, pad.top, 0, height - pad.bottom);
    bandGradient.addColorStop(0, 'rgba(198,255,61,.16)');
    bandGradient.addColorStop(1, 'rgba(198,255,61,.035)');
    ctx.fillStyle = bandGradient;
    ctx.fill();

    const goalY = y(data.targetWeight);
    ctx.save();
    ctx.setLineDash([6, 7]);
    ctx.strokeStyle = 'rgba(198,255,61,.20)';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(pad.left, goalY);
    ctx.lineTo(width - pad.right, goalY);
    ctx.stroke();
    ctx.restore();

    const lineWeeks = Math.min(result.centralWeeks, maxWeeks);
    ctx.save();
    ctx.beginPath();
    for (let week = 0; week <= lineWeeks; week += 1) {
      const px = x(week);
      const py = y(projected(week, result.actualWeeklyLoss));
      if (week === 0) ctx.moveTo(px, py);
      else ctx.lineTo(px, py);
    }
    ctx.strokeStyle = '#c6ff3d';
    ctx.lineWidth = 3.25;
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    ctx.shadowColor = 'rgba(198,255,61,.30)';
    ctx.shadowBlur = 10;
    ctx.stroke();
    ctx.restore();

    const startX = x(0);
    const startY = y(data.weight);
    ctx.fillStyle = '#c6ff3d';
    ctx.beginPath();
    ctx.arc(startX, startY, 3.5, 0, Math.PI * 2);
    ctx.fill();

    const goalWeek = Math.min(result.centralWeeks, maxWeeks);
    const goalX = x(goalWeek);
    ctx.fillStyle = '#c6ff3d';
    ctx.beginPath();
    ctx.arc(goalX, goalY, 5.5, 0, Math.PI * 2);
    ctx.fill();
    ctx.strokeStyle = '#080808';
    ctx.lineWidth = 2.5;
    ctx.stroke();

    ctx.font = `${compactChart ? '800 11px' : '700 10px'} Arial, sans-serif`;
    ctx.fillStyle = 'rgba(198,255,61,.95)';
    ctx.textAlign = 'right';
    ctx.textBaseline = 'bottom';
    ctx.fillText(`CIEĽ ${formatKg(data.targetWeight)} kg`, width - pad.right, Math.max(pad.top + 12, goalY - 8));
  }

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const form = root.querySelector('[data-calc-form]');
    const results = root.querySelector('[data-calc-results]');
    const error = root.querySelector('[data-calc-error]');
    const editButton = root.querySelector('[data-edit-values]');
    const canvas = root.querySelector('[data-weight-chart]');
    let lastChartData = null;

    restoreState(form);
    form.addEventListener('input', () => saveState(form));
    form.addEventListener('change', () => saveState(form));

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = {
        sex: getFieldValue(form, 'sex'),
        age: Number(getFieldValue(form, 'age')),
        height: Number(getFieldValue(form, 'height')),
        weight: Number(getFieldValue(form, 'weight')),
        targetWeight: Number(getFieldValue(form, 'targetWeight')),
        dailyActivity: getFieldValue(form, 'dailyActivity'),
        training: getFieldValue(form, 'training'),
        steps: getFieldValue(form, 'steps') || 'unknown',
        pace: getFieldValue(form, 'pace') || 'recommended'
      };

      const validationError = validateInputs(data);
      if (validationError) {
        error.textContent = validationError;
        const firstInvalid = form.querySelector(':invalid');
        if (firstInvalid) firstInvalid.focus({ preventScroll: false });
        return;
      }

      error.textContent = '';
      const result = calculate(data);

      root.querySelector('[data-result-calories]').textContent = result.targetCalories.toLocaleString('sk-SK');
      root.querySelector('[data-result-maintenance]').textContent = result.tdee.toLocaleString('sk-SK');
      root.querySelector('[data-result-deficit]').textContent = roundTo(result.actualDeficit, 10).toLocaleString('sk-SK');
      root.querySelector('[data-result-protein]').textContent = result.protein;
      root.querySelector('[data-result-fat]').textContent = result.fat;
      root.querySelector('[data-result-carbs]').textContent = result.carbs;
      root.querySelector('[data-result-weekly]').textContent = formatKg(result.actualWeeklyLoss);
      root.querySelector('[data-result-weekly-range]').textContent = `${formatKg(result.lowLoss)}–${formatKg(result.highLoss)}`;
      root.querySelector('[data-result-goal]').textContent = formatKg(data.targetWeight);
      root.querySelector('[data-result-weeks]').textContent = `${result.fastWeeks}–${result.slowWeeks} týždňov`;
      root.querySelector('[data-practical-protein]').textContent = result.protein;
      root.querySelector('[data-practical-per-meal]').textContent = result.proteinPerMeal;
      root.querySelector('[data-chart-caption]').textContent = `${formatKg(data.weight)} → ${formatKg(data.targetWeight)} kg`;
      root.querySelector('[data-safety-note]').hidden = !result.safetyClamped;

      canvas.setAttribute('aria-label', `Odhadovaný vývoj hmotnosti z ${formatKg(data.weight)} kg na ${formatKg(data.targetWeight)} kg v približne ${result.fastWeeks} až ${result.slowWeeks} týždňoch.`);

      results.hidden = false;
      lastChartData = { data, result };
      requestAnimationFrame(() => {
        drawChart(canvas, data, result);
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        results.scrollIntoView({ behavior, block: 'start' });
      });
    });

    editButton.addEventListener('click', () => {
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      form.scrollIntoView({ behavior, block: 'start' });
      const firstInput = form.querySelector('input');
      if (firstInput) window.setTimeout(() => firstInput.focus({ preventScroll: true }), 450);
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      if (!lastChartData) return;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => drawChart(canvas, lastChartData.data, lastChartData.result), 120);
    }, { passive: true });
  }

  const initializeAll = () => document.querySelectorAll('[data-calorie-calculator]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
